document.body.classList.add('willow-pdp');
  (function(){
    var node = document.querySelector('[data-willow-gallery-config]');
    var config = {};
    if(node){ try { config = JSON.parse(node.textContent) || {}; } catch(e) {} }
    window.WILLOW_GAL = {
      colorSlug: config.colorSlug || '',
      finish: config.finish || ''
    };
    window.WILLOW_VMAP = config.variantMap || {};
  })();
  (function(){

    /* ---- variant -> media scoping: server hides non-selected media; this swaps on variant change ---- */
    function curSku(){
      var inp = document.querySelector('product-info [name="id"]') || document.querySelector('[name="id"]');
      var id = inp && inp.value ? String(inp.value) : null;
      return (id && window.WILLOW_VMAP) ? (window.WILLOW_VMAP[id] || null) : null;
    }
    function applyVariant(gallery, sku){
      if(!sku){ return; }
      var nodes = gallery.querySelectorAll('[data-willow-vsku]');
      Array.prototype.forEach.call(nodes, function(el){ el.hidden = el.getAttribute('data-willow-vsku') !== sku; });
    }
    /* Ongoing variant->media scoping (change listener + Section-Rendering observer) is owned by the
       willow-variant-media snippet, which calls back into each gallery's __willowUpd(). We only seed the
       initial scope in init() below — no duplicate listener/interval here. */
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    var ICON = {
      images:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><rect x='3' y='4' width='18' height='14' rx='2'/><circle cx='8.5' cy='9' r='1.5'/><path d='M21 15l-5-5-8 8'/></svg>",
      video:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linejoin='round'><polygon points='7 4 20 12 7 20 7 4'/></svg>",
      rot:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><path d='M20 12c0 2.2-3.6 4-8 4s-8-1.8-8-4 3.6-4 8-4'/><path d='M16 5l4 3-4 3'/></svg>",
      ar:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linejoin='round'><path d='M12 3l8 4.5v9L12 21l-8-4.5v-9z'/><path d='M12 12l8-4.5M12 12v9M12 12L4 7.5'/></svg>",
      expand:"<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M3 3V9M3 3H9M3 3L9 9M21 21V15M21 21H15M21 21L15 15'/></svg>"
    };

    function curFinish(){
      var slug = window.WILLOW_GAL.colorSlug;
      if(slug){
        var inp = document.querySelector('.variant-input-wrapper[data-option-slug="' + slug + '"] input:checked');
        if(inp){ var v = inp.getAttribute('data-option-value'); if(v){ return v.trim(); } }
      }
      return window.WILLOW_GAL.finish || '';
    }

    document.addEventListener('lightbox:open', function(event){
      var gallery = event.target.closest && event.target.closest('media-gallery.product__gallery');
      if(!gallery){ return; }
      enableZoomThumbs(gallery);
      var lightbox = gallery.photoswipe;
      if(!lightbox || lightbox.__willowFocusReturn){ return; }
      lightbox.__willowFocusReturn = true;
      lightbox.on('close', function(){
        var expand = gallery.querySelector('.willow-gal-expand');
        if(lightbox.pswp && expand){
          lightbox.pswp._lastActiveElement = expand;
        }
      });
    }, true);

    function enableZoomThumbs(gallery){
      var lightbox;
      try { lightbox = gallery.photoswipe; } catch(e) { return; }
      if(!lightbox || lightbox.__willowThumbs){ return; }
      lightbox.__willowThumbs = true;
      // Leave room for the strip without covering the enlarged image.
      var originalPadding = lightbox.options.paddingFn;
      var basePadding = lightbox.options.padding || {};
      lightbox.options.paddingFn = function(viewport, item, index){
        var padding = originalPadding ? originalPadding(viewport, item, index) : basePadding;
        return Object.assign({}, padding, {bottom: Math.max((padding || {}).bottom || 0, 112)});
      };
      lightbox.on('uiRegister', function(){
        var pswp = lightbox.pswp;
        if(!pswp || !pswp.ui){ return; }
        pswp.ui.registerElement({
          name: 'willow-thumbs',
          order: 9,
          isButton: false,
          appendTo: 'root',
          html: '',
          onInit: function(el, instance){
            el.classList.add('willow-zoom-thumbs');
            var track = document.createElement('div');
            track.className = 'willow-zoom-thumbs-track';
            track.setAttribute('role', 'group');
            track.setAttribute('aria-label', 'Product photos');
            var count = instance.getNumItems();
            for(var i = 0; i < count; i++){
              // Read PhotoSwipe's actual filtered items, never the unfiltered thumbnail order.
              var item = instance.getItemData(i) || {};
              var sourceImg = item.thumbnailElement;
              var src = item.msrc || (sourceImg && (sourceImg.currentSrc || sourceImg.src)) || item.src || '';
              var button = document.createElement('button');
              button.type = 'button';
              button.className = 'willow-zoom-thumb';
              button.setAttribute('data-index', String(i));
              var label = item.alt || (sourceImg && sourceImg.alt) || '';
              button.setAttribute('aria-label', 'View photo ' + (i + 1) + ' of ' + count + (label ? ': ' + label : ''));
              if(!src){ button.textContent = String(i + 1); }
              if(src){
                var image = document.createElement('img');
                image.src = src;
                image.alt = '';
                image.loading = 'lazy';
                button.appendChild(image);
              }
              track.appendChild(button);
            }
            el.appendChild(track);
            track.addEventListener('click', function(event){
              var button = event.target.closest && event.target.closest('.willow-zoom-thumb');
              if(!button){ return; }
              instance.goTo(parseInt(button.getAttribute('data-index'), 10));
            });
            function sync(){
              var current = instance.currIndex;
              track.querySelectorAll('.willow-zoom-thumb').forEach(function(button, index){
                var active = index === current;
                button.classList.toggle('is-active', active);
                button.setAttribute('aria-current', active ? 'true' : 'false');
                if(active){
                  button.scrollIntoView({
                    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                    block: 'nearest',
                    inline: 'center'
                  });
                }
              });
            }
            instance.on('change', sync);
            sync();
          }
        });
      });
    }

    function init(gallery){
      if(!gallery || gallery.__willowGal){ return; }
      var slider = gallery.querySelector('slider-element');
      if(!slider || !slider.parentElement || !gallery.querySelector('.product__media')){ return; }
      gallery.__willowGal = true;

      var mediaCol = slider.parentElement;                       /* .relative.w-full.h-full */
      var container = gallery.querySelector('.product__media-container');
      var thumbsWrap = gallery.querySelector('.product__thumbnails');
      var thumbsList = gallery.querySelector('.product__thumbnails-list');
      mediaCol.classList.add('willow-media-col');
      if(container){ container.classList.add('willow-media-container'); }
      if(thumbsWrap){ thumbsWrap.classList.add('willow-thumbs'); }
      enableZoomThumbs(gallery);

      function thumbs(){ return gallery.querySelectorAll('.product__thumbnail:not([hidden])'); }
      function activeThumb(){ return gallery.querySelector('.product__thumbnail[aria-current="true"]:not([hidden])'); }
      var swipePage = 0;
      function curIdx(){
        if(swipePage){ return Math.min(swipePage, total()); }
        var list = Array.prototype.slice.call(thumbs());
        var i = list.indexOf(activeThumb());
        return i >= 0 ? i + 1 : 1;
      }
      function total(){ return thumbs().length || (slider.itemsToShow && slider.itemsToShow.length) || gallery.querySelectorAll('.product__media:not([hidden])').length || 1; }
      function curMediaId(){
        var currentSlide = slider.itemsToShow && slider.itemsToShow[curIdx() - 1];
        var id = currentSlide && currentSlide.getAttribute('data-media-id');
        if(id){ return id; }
        var a = activeThumb();
        return a ? a.getAttribute('data-media-id') : null;
      }

      /* --- counter + caption ---
         They remain two independent pills with their original sizes. The wrapper only groups their
         mobile position at the bottom-right; on desktop it has no layout effect. */
      var meta = document.createElement('div');
      meta.className = 'willow-gal-meta';

      var counter = document.createElement('div');
      counter.className = 'willow-gal-counter';
      meta.appendChild(counter);

      var caption = document.createElement('div');
      caption.className = 'willow-gal-caption';
      meta.appendChild(caption);

      mediaCol.appendChild(meta);

      /* --- expand --- */
      var expand = document.createElement('button');
      expand.type = 'button';
      expand.className = 'willow-gal-expand';
      expand.setAttribute('aria-label', gallery.getAttribute('aria-label'));
      expand.innerHTML = ICON.expand;
      expand.addEventListener('click', function(){
        var id = curMediaId();
        var btn = id
          ? gallery.querySelector('.product__media[data-media-id="' + id + '"] button[is*="media-"][is*="button"]')
          : gallery.querySelector('.product__media button[is*="media-"][is*="button"]');
        if(btn){ btn.click(); }
      });
      mediaCol.appendChild(expand);

      /* Tap the PHOTO itself → open the zoom (consistent with the colour / countertop detail popups,
         which also enlarge on tap). A swipe doesn't fire a click, so sliding between photos still works;
         taps on the controls/thumbnails are ignored so they keep their own behaviour. */
      mediaCol.addEventListener('click', function(e){
        if (e.target.closest('.willow-gal-expand, .willow-gal-nav, .willow-rail, .willow-thumb-more, .product__thumbnail, a, [data-sticky-product-media]')) return;
        if (e.target.closest('.product__media')) { expand.click(); }
      });

      /* --- prev / next arrows (tap to move through the gallery) --- */
      function navTo(dir){
        var list = Array.prototype.slice.call(thumbs());
        if(!list.length){ return; }
        var i = list.indexOf(activeThumb()); if(i < 0){ i = 0; }
        var ni = (i + dir + list.length) % list.length;
        if(list[ni]){ list[ni].click(); }
      }
      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'willow-gal-nav willow-gal-prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.innerHTML = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M15 18l-6-6 6-6'/></svg>";
      prevBtn.addEventListener('click', function(){ navTo(-1); });
      mediaCol.appendChild(prevBtn);
      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'willow-gal-nav willow-gal-next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.innerHTML = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M9 18l6-6-6-6'/></svg>";
      nextBtn.addEventListener('click', function(){ navTo(1); });
      mediaCol.appendChild(nextBtn);

      /* --- media rail --- */
      var hasVideo = !!gallery.querySelector('.product__media[data-media-type="video"], .product__media[data-media-type="external_video"]');
      var rail = document.createElement('div');
      rail.className = 'willow-gal-rail';
      rail.innerHTML =
        "<button type='button' class='willow-rail-tab is-active' data-tab='images'>" + ICON.images + "<span>Images</span></button>" +
        "<button type='button' class='willow-rail-tab" + (hasVideo ? '' : ' is-disabled') + "' data-tab='video'>" + ICON.video + "<span>Video</span></button>" +
        "<button type='button' class='willow-rail-tab is-disabled' data-tab='r360' title='Coming soon'>" + ICON.rot + "<span>360°</span></button>" +
        "<button type='button' class='willow-rail-tab is-disabled' data-tab='ar' title='Coming soon'>" + ICON.ar + "<span>AR View</span></button>";
      mediaCol.appendChild(rail);
      rail.addEventListener('click', function(e){
        var b = e.target.closest('.willow-rail-tab');
        if(!b || b.classList.contains('is-disabled')){ return; }
        rail.querySelectorAll('.willow-rail-tab').forEach(function(t){ t.classList.toggle('is-active', t === b); });
        var tab = b.getAttribute('data-tab');
        var th = thumbs();
        if(tab === 'images' && th[0]){ th[0].click(); }
        if(tab === 'video'){
          var vid = gallery.querySelector('.product__media[data-media-type="video"], .product__media[data-media-type="external_video"]');
          if(vid){
            var vt = gallery.querySelector('.product__thumbnail[data-media-id="' + vid.getAttribute('data-media-id') + '"]');
            if(vt){ vt.click(); }
          }
        }
      });

      /* --- bottom thumbnail rail --- */
      function overflow(){
        if(!thumbsList){ return; }
        var items = thumbsList.querySelectorAll('.product__thumbnail:not([hidden])');
        var more = thumbsList.querySelector('.willow-thumb-more');
        Array.prototype.forEach.call(items, function(it){ it.style.display = ''; });
        if(more){ more.remove(); }
        var active = activeThumb();
        if(active && thumbsList.clientWidth){
          var left = Math.max(0, active.offsetLeft - (thumbsList.clientWidth - active.offsetWidth) / 2);
          if(Math.abs(thumbsList.scrollLeft - left) > 2){
            thumbsList.scrollTo({
              left: left,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
      }

      function upd(resetPage){
        if(resetPage){ swipePage = 0; }
        var counterLabel = pad(curIdx()) + ' / ' + pad(total());
        if(counter.textContent !== counterLabel){ counter.textContent = counterLabel; }
        var f = curFinish();
        var ctInp = document.querySelector('.variant-input-wrapper[data-option-slug*="countertop"] input:checked');
        var ct = ctInp ? (ctInp.getAttribute('data-option-value') || '').trim() : '';
        var captionLabel = (f || '') + (ct ? ' · ' + ct : '');
        if(caption.textContent !== captionLabel){ caption.textContent = captionLabel; }
        caption.style.display = captionLabel ? '' : 'none';
        /* keep video tab availability fresh (media can load late) */
        var vTab = rail.querySelector("[data-tab='video']");
        if(vTab && gallery.querySelector('.product__media[data-media-type="video"], .product__media[data-media-type="external_video"]')){
          vTab.classList.remove('is-disabled');
        }
        overflow();
      }

      upd();
      if(thumbsWrap){ thumbsWrap.classList.add('willow-thumbs--ready'); }
      gallery.__willowUpd = upd;
      gallery.__willowSku = curSku();
      if(gallery.__willowSku){ applyVariant(gallery, gallery.__willowSku); }
      /* Debounced observer replaces the old 1s interval: coalesce DOM bursts into one upd per frame,
         and watch childList too so late-loading media (counter total / video tab) stays fresh. */
      var raf;
      function updSoon(){ if(raf){ return; } raf = requestAnimationFrame(function(){ raf = 0; upd(); }); }
      /* Native mobile swipes emit slider:change, but hidden thumbnails have zero width and the
         theme's MediaDots cannot update aria-current. Read the real slider page directly instead. */
      slider.addEventListener('slider:change', function(event){
        var page = event.detail && parseInt(event.detail.currentPage, 10);
        swipePage = page > 0 ? Math.min(page, total()) : 0;
        updSoon();
      });
      /* iOS can delay or omit scrollend while momentum settles. A passive, frame-throttled
         fallback keeps the visible counter in sync during the gesture itself. */
      var scrollRaf=0;
      slider.addEventListener('scroll', function(){
        if(scrollRaf){ return; }
        scrollRaf=requestAnimationFrame(function(){
          scrollRaf=0;
          var step=slider.itemOffset || slider.clientWidth;
          if(!step){ return; }
          swipePage=Math.max(1,Math.min(total(),Math.round(Math.abs(slider.scrollLeft)/step)+1));
          updSoon();
        });
      }, {passive:true});
      /* Watch only the media dots. The former gallery-wide observer reacted to every
         custom control and app mutation. */
      if(thumbsList && !gallery.__willowObs){
        gallery.__willowObs = new MutationObserver(updSoon);
        gallery.__willowObs.observe(thumbsList, { subtree:true, childList:true, attributes:true, attributeFilter:['aria-current','hidden'] });
      }
    }

    /* (Re)build the gallery chrome. On a variant change the theme re-renders the gallery (Section
       Rendering), which REPLACES the media DOM and drops our counter / caption / expand / arrows —
       so init's `__willowGal` guard would otherwise leave the new gallery bare. Detect that (our
       counter is gone from the current media column) and re-initialise. */
    function ensure(){
      document.querySelectorAll('media-gallery.product__gallery').forEach(function(g){
        enableZoomThumbs(g);
        var sl = g.querySelector('slider-element');
        var col = sl && sl.parentElement;
        if(!col || !col.querySelector('.willow-gal-counter')){
          g.__willowGal = false;
          if(g.__willowObs){ try{ g.__willowObs.disconnect(); }catch(e){} g.__willowObs = null; }
          init(g);
        }
      });
    }
    function boot(){ ensure(); }
    if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    [400, 1000, 2200, 3500].forEach(function(t){ setTimeout(boot, t); });
    /* Re-run after the async variant re-render lands. The `change` fires before the DOM swap, so also
       watch the product area for the actual swap (debounced; ensure() is cheap and a no-op once the
       chrome is present). */
    var ensRaf;
    function ensureSoon(){ if(ensRaf){ return; } ensRaf = requestAnimationFrame(function(){ ensRaf = 0; ensure(); }); }
    document.addEventListener('variant:change', ensureSoon, true);
    document.addEventListener('shopify:section:load', ensureSoon);
    var hostEl = document.querySelector('.main-product') || document.getElementById('MainContent') || document.body;
    try{
      new MutationObserver(function(records){
        for(var i=0;i<records.length;i++){
          var target=records[i].target;
          if(target && target.nodeType===1 && target.closest &&
             target.closest('media-gallery.product__gallery') &&
             !target.closest('.willow-gal-counter,.willow-gal-caption,.willow-thumb-more')){
            ensureSoon(); return;
          }
          var changed=[].slice.call(records[i].addedNodes).concat([].slice.call(records[i].removedNodes));
          for(var j=0;j<changed.length;j++){
            var node=changed[j];
            if(node && node.nodeType===1 &&
              ((node.matches && node.matches('media-gallery.product__gallery')) ||
               (node.querySelector && node.querySelector('media-gallery.product__gallery')))){
              ensureSoon(); return;
            }
          }
        }
      }).observe(hostEl, { childList:true,subtree:true });
    }catch(e){}
  })();


